const MESSAGES = {
  FIRST_START: "Начни игру!", // При первом открытии страницы

  START: "Расшифруй код.", // Начало игры после «Начать игру» и «Играть ещё»

  // Сообщения при проверке слова
  WORD_WRONG: "Неверно. Попробуй ещё раз.",

  // Завершение раунда и игры
  ROUND_FINISHED: "Молодец! Нажми «Далее».",
  GAME_FINISHED: "Все слова отгаданы. Нажми «Играть ещё».",
} as const;

export default MESSAGES;